module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Blood Before Dawn")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "contributors"
    }
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iii",
      "title": "iii"
    }
  }, [_vm._v("PRAISE FOR BLOOD BEFORE DAWN AND AUTHOR DANIEL V. MEIER, JR.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("“Meier continues his "), _c('i', [_vm._v("The Dung Beetles of Liberia")]), _vm._v(" series with this enthralling installment as Ken Verrier returns to Liberia to buy diamonds. It’s April of 1979. When Ken, accompanied by his strong-willed wife, Sam, planned to return to Liberia to buy diamonds, he had no idea the country was entering a devastatingly tumultuous period of political unrest. Will he get out alive? Meier’s insights into the ways corruption, injustice, and atrocities hollow out a nation’s soul are cleareyed. His prose is intelligent, the narrative engrossing, and his unflinching forays into the African nation’s social, cultural, and political atmosphere are realistic. Along the way, he weaves in a high-profile assassination, suspense, and daring escapades, keeping readers invested. From its adrenaline-fueled opening to its surprising conclusion, this poignant novel brilliantly captures the population’s unrest and the white-hot fury as they struggle to obtain the basic necessities of life. This is a powerful story of civil unrest, corruption, and the arbitrary division between the masses.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("— "), _c('i', [_vm._v("The Prairies Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("“. . . In both books, "), _c('i', [_vm._v("The Dung Beetles of Liberia")]), _vm._v(" and this sequel, "), _c('i', [_vm._v("Blood Before Dawn")]), _vm._v(", author Daniel V. Meier, Jr. captures the essence of Africa. It’s a continent that is both majestic and undeniably cruel. It’s the battlefield where the clash between foreign influence with western ideals of life and a fair standard of living, tribalism, lack of compassion, minimal sanctity of life, and belief in witchcraft meet and struggle. Meier throws the Americans into this mix, who are worried that either China or Russia is gaining "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_vm._v("inroads into an area they wish to influence, and this lights the touch paper to the revolution. No one is safe; men’s basest behaviors are unleashed, destroying lives and livelihoods. . . . The story itself takes the reader on a page-turning, fast-moving exciting ride, and I found myself holding my breath as I flew through the chapters . . . this is another read that will stay with me for years to come.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("— Lucinda E. Clarke for "), _c('i', [_vm._v("Readers’ Favorite")]), _vm._v(" reviews")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("“. . . Daniel V. Meier, Jr. has written another compelling historical fiction narrative in "), _c('i', [_vm._v("Blood Before Dawn")]), _vm._v(". Readers hit the ground running in the beginning scenes (along with the main characters, much to their horror) while the suspenseful and harrowing story of the corrupt political environment and unrest in Liberia unfolds and doesn’t subside until the shockingly messy conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is evident that the author is a master of writing in the historical fiction genre, whether he is spinning a tale partly from his personal experience as seen in this series, or with his other equally engaging historical fiction works. Readers are not just told a wild, fictional story that might have some basis in history, but they’re presented with an entertaining story expertly woven throughout real events in the tumultuous history of Liberia. . . . "), _c('i', [_vm._v("Blood Before Dawn")]), _vm._v(". . . will not only linger in your thoughts, but it also has the potential to awaken your thirst for knowledge.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("— Lynette Latzko, "), _c('i', [_vm._v("Feathered Quill Book Reviews")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 63
// module chunks = 0